 import ReactiveWidget from "lib/reactiveWidget";
 import { numberWithCommas, allowNumericOnly, isNumericOnly, numberClearCommas } from 'servos/formValidations'

class applyNowWidget extends ReactiveWidget  {
  bind() {
    applyNow.call(this);
    applyCommas.call(this);
  }

  render() {
  }
}

let applyCommas = function() {
  this.root.on("keyup", "#loan-amount", (e) => {
    allowNumericOnly(e)
    numberWithCommas(e)
    $('#apply-now').toggleClass("disabled", (!isNumericOnly(numberClearCommas(e.currentTarget.value))))
  })
}

let applyNow = function() {
  this.root.find('#apply-now').on("click", (e) => {
    const onboardingForm = document.querySelectorAll('.onboarding-form.active')
    const loanPurpose = onboardingForm[0].textContent
    const loanTarget = onboardingForm[1].id
    const loanAmount = numberClearCommas(document.querySelector('#loan-amount').value)

    if (isNumericOnly(loanAmount)) {
      window.location.href = `/onboarding_funnel/new?loanPurpose=${loanPurpose}&loanTarget=${loanTarget}&loanAmount=${loanAmount}`
    }
  })
}

export default applyNowWidget
